var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgInformationIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 19 20",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 19.765c5.177 0 9.463-4.296 9.463-9.463 0-5.177-4.296-9.463-9.472-9.463C4.323.839.037 5.125.037 10.302c0 5.167 4.296 9.463 9.463 9.463zm-.093-12.85a1.25 1.25 0 01-1.252-1.261 1.25 1.25 0 011.252-1.262c.696 0 1.243.557 1.243 1.262s-.547 1.262-1.243 1.262zm-1.586 8.666c-.4 0-.705-.288-.705-.687 0-.371.306-.677.705-.677h1.178v-4.36h-1.02a.676.676 0 01-.696-.687c0-.371.306-.677.696-.677h1.8c.491 0 .75.352.75.872v4.852h1.179c.399 0 .705.306.705.677 0 .399-.306.687-.705.687H7.821z",
    fill: "#7A7A7B"
  })));
}

export default SvgInformationIcon;